import styled from '@emotion/styled'
import { FlexCenter, Transition } from '@oneToOne/shared/styles'

export const ButtonRow = styled.div`
  ${Transition}
  ${FlexCenter}
  gap: var(--spacing-16);
`
